export default __webpack_public_path__ + "static/media/printer.f4add016.svg";